<script>
import Auth from '@/pages/layouts/auth.vue';
import Input from "@/pages/components/form/vertical/input.vue";
import {useForm} from "@inertiajs/vue3";

export default {
  components: {
    Auth,
    Input
  },
  props: {
    email: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true,
    }
  },
  methods: {
    submit() {
      this.form.post(route('password.store'), {
        onFinish: () => this.form.reset('password', 'password_confirmation')
      });
    }
  },
  data() {
    return {
      form: useForm({})
    }
  },
  mounted() {
    this.form.defaults({
      token: this.token,
      email: this.email,
      password: '',
      password_confirmation: '',
    });
    this.form.reset();
  }
}
</script>

<template>
  <Auth title="Wachtwoord resetten">
    <form class="form-horizontal form-material" @submit.prevent="submit">
      <Input v-model="form.email" :form="form" type="email" name="email" required autofocus autocomplete="username" placeholder="E-mail"/>
      <Input v-model="form.password" :form="form" type="password" name="password" required placeholder="Wachtwoord"/>
      <Input v-model="form.password_confirmation" :form="form" type="password" name="password_confirmation" required placeholder="Herhaal wachtwoord"/>

      <div class="form-group">
        <button :disabled="form.processing" class="btn w-100 btn-lg btn-primary btn-rounded text-white" type="submit">Wachtwoord resetten</button>
      </div>
    </form>
  </Auth>
</template>